if (!customElements.get('mega-menu-desktop')) {
  class MegaMenuDesktop extends HTMLElement {
    constructor() {
      super();
      this.activeSubMenu = null;
      this.activeDetails = null;
      this.hoverTimeout = null;
    }

    connectedCallback() {
      this.setupMegaMenus();
    }

    setupMegaMenus() {
      const megaMenus = document.querySelectorAll('.mega-menu-dropdown');
      megaMenus.forEach(megaMenu => this.setupMegaMenu(megaMenu));
    }

    setupMegaMenu(megaMenu) {
      const detailsElements = megaMenu.querySelectorAll('.mega-menu--links details');
      const subLinksContainer = megaMenu.querySelector('.mega-menu-sublinks-container') || this.createSubLinksContainer(megaMenu);

      detailsElements.forEach(details => {
        const summary = details.querySelector('summary');
        const subLinks = details.querySelector('.mega-menu-new__sublinks');

        if (!summary || !subLinks) return;

        details.addEventListener('toggle', (e) => {
          e.preventDefault();
          details.removeAttribute('open');
        });

        summary.addEventListener('mouseenter', () => {
          this.showSubMenu(subLinks, subLinksContainer, details);
        });

        summary.addEventListener('mouseleave', (e) => {
          this.scheduleHideSubMenu(e, subLinksContainer);
        });
      });

      subLinksContainer.addEventListener('mouseenter', () => {
        this.cancelHideSubMenu();
      });

      subLinksContainer.addEventListener('mouseleave', () => {
        this.hideSubMenu(subLinksContainer);
      });

      megaMenu.addEventListener('mouseleave', () => {
        this.hideSubMenu(subLinksContainer);
      });
    }

    createSubLinksContainer(megaMenu) {
      const container = document.createElement('div');
      container.className = 'mega-menu-sublinks-container';

      const megaMenuBlock = megaMenu.querySelector('.mega-menu-block');
      if (megaMenuBlock) {
        megaMenuBlock.appendChild(container);
      }

      return container;
    }

    showSubMenu(subLinks, container, parentDetails) {
      this.cancelHideSubMenu();

      if (this.activeDetails === parentDetails) return;

      if (this.activeDetails) {
        this.activeDetails.classList.remove('active');
      }

      container.innerHTML = subLinks.outerHTML;
      const clonedSubLinks = container.querySelector('.mega-menu-new__sublinks');

      if (clonedSubLinks) {
        container.classList.add('is-visible');
        clonedSubLinks.style.position = 'static';
        clonedSubLinks.style.width = 'auto';
        clonedSubLinks.style.height = 'auto';

        parentDetails.classList.add('active');

        this.activeSubMenu = clonedSubLinks;
        this.activeDetails = parentDetails;
      }
    }

    scheduleHideSubMenu(event, container) {
      const relatedTarget = event.relatedTarget;
      if (relatedTarget && (container.contains(relatedTarget) || relatedTarget === container)) {
        return;
      }

      this.hoverTimeout = setTimeout(() => {
        this.hideSubMenu(container);
      }, 150);
    }

    cancelHideSubMenu() {
      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = null;
      }
    }

    hideSubMenu(container) {
      this.cancelHideSubMenu();
      container.classList.remove('is-visible');
      container.innerHTML = '';

      if (this.activeDetails) {
        this.activeDetails.classList.remove('active');
      }

      this.activeSubMenu = null;
      this.activeDetails = null;
    }
  }

  customElements.define('mega-menu-desktop', MegaMenuDesktop);
}
